//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        formEl: { type: Object },
        index: { type: Number, default: null },
    },
    data() {
        return {
            placeholder: null,
        }
    },
    mounted() {
        this.placeholder =
            this.formEl.options.placeholder || 'Ce message sera uniquement envoyé à votre relationship manager.'
    },
    methods: {
        onInput(e) {
            this.$emit('input', e.target.value)
        },
        onFocus() {
            this.placeholder = null
        },
        onBlur() {
            this.placeholder =
                this.formEl.options.placeholder || 'Ce message sera uniquement envoyé à votre relationship manager.'
        },
    },
}
